import { useQuickPostV3ModalStore } from "@circle-react/components/QuickPostV3/store";
import {
  useMdScreenMediaQuery,
  useSmScreenMediaQuery,
} from "@circle-react/hooks/useMediaQuery";

export const useComposerLayout = () => {
  const isFullscreen = useQuickPostV3ModalStore(state => state.isFullscreen);
  const isSmScreen = useSmScreenMediaQuery();
  const isMdScreen = useMdScreenMediaQuery();
  const isFullScreenLayout = isFullscreen || isSmScreen;

  return {
    isMdScreen,
    isSmScreen,
    isFullScreenLayout,
    shouldInlineTopics: isFullScreenLayout && isMdScreen,
  };
};
